module.exports = __webpack_public_path__ + "static/media/TechBoy.b85f93d9.png";